/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { store } from 'reduxStore'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import routes from 'routes'

import SectionTitle from 'components/Common/SectionTitle'
import ToolTip from 'components/Common/ToolTip'
import Overlay from 'components/Common/Overlay'
import ConnectButton from 'components/Common/Button/ConnectButton'
import VaultSummary from './VaultSummary'

const VaultSummaryContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxHeight: '450px',
  overflowY: 'auto',
}))

const VaultCard = props => {
  const navigate = useNavigate()

  const userData = store.getState().userReducer.user
  const vaultInfo = useSelector(state => state.apiResponseReducers.dashboardInfo?.vault_info)
  const [showOverlay, setShowOverlay] = useState(false)

  const checkIfMFAEnabled = () => {
    //TODO: Check the login user is using MFA
    return false
  }

  const onClickEnterVault = (verified = false) => {
    if (checkIfMFAEnabled()) {
      navigate(routes.vault)
    } else {
      navigate(routes.vaultVerification)
    }
  }

  const tooltipContent = (
    <Typography variant="body2" color="white">
      Upload key business artifacts (e.g., EIN, Beneficial Owners, tax returns) to securely store and organize your
      documents.
    </Typography>
  )

  return (
    <Box
      onMouseOver={() => setShowOverlay(true)}
      onMouseLeave={() => setShowOverlay(false)}
      sx={{
        height: '100%',
        position: 'relative',
      }}
    >
      {!!showOverlay && userData?.accountType === 'free' && (
        <>
          <Overlay>
            <Box
              sx={{
                height: 'calc(100% - 100px)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-around',
              }}
            >
              <Typography
                component="div"
                variant="body1B"
                color="white"
                sx={{
                  width: '70%',
                  textAlign: 'center',
                  marginTop: 2.5,
                }}
              >
                Use our secure 'digital filing system' to upload your company's artifacts, and share them on a consent
                basis with Markaaz, other users on the platform or third parties.
              </Typography>
            </Box>
          </Overlay>
        </>
      )}

      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 1.25,
          padding: '25px',
        }}
      >
        <Box>
          <SectionTitle title="Vault" />
          &nbsp;
          <ToolTip content={tooltipContent} />
        </Box>

        <VaultSummaryContainer>
          <VaultSummary />
        </VaultSummaryContainer>
        <Box sx={{ width: '100%', marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ConnectButton
            onClick={onClickEnterVault}
            label="Enter your Vault"
            isConnected={!!vaultInfo.document_count || !!vaultInfo.owner_count}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default VaultCard
